module.exports = __webpack_public_path__ + "static/media/feed.a5d05255.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/feed.svg
// module id = 2827
// module chunks = 7